import MyAlert from './MyAlert.vue'
export default MyAlert
